import { RegimeAnalytics } from '../../types/entities';

export interface RegimeAnalyticsState {
  loading: boolean;
  loaded: boolean;
  error?: string;
  regimeAnalytics: RegimeAnalytics | undefined;
}

export const initialRegimeAnalyticsState: RegimeAnalyticsState = {
  loading: false,
  loaded: false,
  error: undefined,
  regimeAnalytics: undefined
};
